import { Box } from "@mui/material";

interface CustomTimeSlotWrapperProps {
  value: Date;
  children: React.ReactNode;
  className: string;
}

export const CustomTimeSlotWrapper = ({
  children,
  className,
}: CustomTimeSlotWrapperProps) => {
  return <Box className={className}>{children}</Box>;
};
